export default {
      id: "thermo-b-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#thermo-b-usage",
      toString: function () {
        return this.url;
      }
    }